var map = {
	"./TsAcademicYearFilter": "671f",
	"./TsAudioRecorder": "e569",
	"./TsBranchFilter": "8776",
	"./TsBranchFilters": "5eba",
	"./TsBreadcrumb": "b750",
	"./TsButton": "7e4d",
	"./TsCard": "2084",
	"./TsCardWrapper": "68e7",
	"./TsCheckbox": "3b02",
	"./TsDatePickerInput": "57ad",
	"./TsDatePickerInputs": "b1a3",
	"./TsImageInput": "16a7",
	"./TsInput": "6b4cb",
	"./TsLoadingBanner": "cd2c",
	"./TsLockScreen": "d79d",
	"./TsModalCloseButton": "22da",
	"./TsMonthPickerInput": "9e8d",
	"./TsPagination": "1751",
	"./TsPreviewPdf": "8bfc",
	"./TsRadio": "deaf",
	"./TsSearchSelect": "1f9c",
	"./TsSelect": "8362",
	"./TsTab": "8e19",
	"./TsTable": "5ca3",
	"./TsTextarea": "7730",
	"./TsTimePickerInput": "6b8b",
	"./TsTotalList": "3e6f",
	"./TsWaiting": "d2f9",
	"./TsYearPickerInput": "036f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "140b";